import { useContext } from 'react';
import GeneralContext from '../../../context/GeneralContext';

const SelectAccountLogic = () => {
  const { lan, setGeneralValues } = useContext(GeneralContext);

  return { lan, setGeneralValues };
};
export default SelectAccountLogic;
